import { useEffect, useRef } from "react";
import { ScrollView } from "tamagui";

export const useScrollbarFlash = (
  offset = 30,
  duration = 500,
  enabled = true,
) => {
  const scrollRef = useRef<ScrollView | null>(null);
  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!enabled) return;
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ y: offset, animated: true });
      timeoutId.current = setTimeout(() => {
        scrollRef.current?.scrollTo({ y: 0, animated: true });
      }, duration);
    }
    return () => clearTimeout(timeoutId.current!);
  }, [offset, duration, enabled]);

  return { scrollRef };
};
